import { useIntl } from 'umi';
import SvgIcon from '@/pages/home/components/SvgIcon';
import TipContext from './components/TipContext';
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { Bubble, Dropdown, List } from 'tea-component';
import classNames from 'classnames';
import './index.scss';
export interface SortByListItemType {
  key: string; // 排序指标的key， 后面可以跟ratioType作为后缀
  text: string | any;
  title: string | any;
  orderSource?: string; // 排序指标属于的数据源
  sortMetric?: string; // 排序指标 order_metric
  ratioType?: number; // 后端排序用 0 为值排序， 1为环比排序
  sortMetricNew?: number; // 后端排序用 0 为值排序， 1为环比排序 -- 新
  dataSourceNew?: number; // 后端排序用 0 为值排序， 1为环比排序 -- 新
}
export interface SortByItemType {
  key: string | undefined;
  sortVal: string; // 'asc' | 'desc';
  sortMetric?: string; // 排序指标 order_metric
  ratioType?: number; // 后端排序用 0 为值排序， 1为环比排序
  orderSource?: string; // 排序指标属于的数据源
  sortMetricNew?: number; // 后端排序用 0 为值排序， 1为环比排序 -- 新
  dataSourceNew?: number; // 后端排序用 0 为值排序， 1为环比排序 -- 新
  orderType?: string; // 'asc' | 'desc';
  order_device?: string;
  title?: string;
  title_en?: string;
  title_cn?: string;
}

type sortType = 'asc' | 'desc';

//  svgIcon 传入的svg
// svgIcon1 如果有第二的svg
// tipText  如果有提示
// title  标题
// svgTip   svg提示
interface SortByProps {
  defaultValue: '' | sortType; // 'desc' | 'asc' | ''; //排序值
  align?: 'left' | 'right' | 'center';
  defaultKey: string; // 正在排序的值
  className?: string;
  svgIcon?: string;
  svgIcon1?: string;
  svgTip?: React.ReactNode;
  title: string | any; // 标题
  content?: React.ReactNode; // 标题提示
  tipText?: React.ReactNode;
  isNoDropdown?: boolean;
  list?: SortByListItemType[] /** 排序下拉列表，length==1时不展示下拉，但展示排序 */;
  onChange?: (e: SortByItemType) => void;
  // rightWidth: string; // 表格居中右对齐宽度
  onlySimpleSort?: boolean; // 是否只有一个排序
  isSourceMetricBub?: boolean; // 是否为数据源与指标合体
  type?: string; // 区别由前端筛选类型
  filter?: any; // 前端筛选方法
  disabled?: boolean; // 是否禁用
  maxWidth?: number; // 最大宽度
  keysContent?: string; // 内容
  // 是否展示气泡，默认展示
  showTips?: boolean;
  dropdownBoxClassName?: string;
  isMetricExplanation?: boolean;
  onMetricExplanationClick?: any;
  onClickViewCalibrationData?: (metric: string) => void;
  // 列标题的cursor是否设置为pointer样式，默认为false
  titlePointerCursor?: boolean;
}

export default function SortBy(props: SortByProps) {
  const {
    svgIcon,
    svgIcon1,
    className,
    title: titleProp,
    disabled,
    tipText,
    svgTip,
    isNoDropdown,
    content,
    defaultValue = '',
    defaultKey,
    list,
    align = 'right',
    onlySimpleSort = false,
    // dataSource,//数据源图标名
    onChange = () => {},
    type,
    filter,
    maxWidth = 500,
    // isSourceMetricBub = false,
    keysContent,
    showTips = true,
    dropdownBoxClassName,
    isMetricExplanation,
    onMetricExplanationClick,
    onClickViewCalibrationData,
    titlePointerCursor = false,
  } = props;

  // console.debug('SortBy', props);

  const { formatMessage } = useIntl();

  const bubbleContentRef = useRef<HTMLDivElement>(null);

  const [title, setTitle] = useState<string>(titleProp);

  const handleBubbleContentClick = (event: React.MouseEvent) => {
    if (!isMetricExplanation) return;

    // Look for clickable links with data-action attributes
    const actionLink = bubbleContentRef.current?.querySelector('a[data-action]') as HTMLAnchorElement;
    if (actionLink) {
      const action = actionLink.getAttribute('data-action');
      const metric = actionLink.getAttribute('data-metric');

      // Handle the viewCalibrationData action directly
      if (action === 'viewCalibrationData' && metric) {
        // Use the onClickViewCalibrationData callback from props
        if (onClickViewCalibrationData) {
          onClickViewCalibrationData(metric);
        } else if (onMetricExplanationClick) {
          onMetricExplanationClick('definition', { key: 'viewCalibrationData', metric });
        }

        // Prevent default link behavior
        event.preventDefault();
        event.stopPropagation();
        return;
      }
    }
  };

  const [action, setAction] = useState<sortType | ''>(defaultValue);
  const [sortKey, setSortKey] = useState<string>(defaultKey);

  let sortList = list || [];
  if (!Array.isArray(list)) {
    sortList = [];
  }

  useEffect(() => {
    const item = sortList.find((t) => t?.key === defaultKey);
    // 没有排序展示不用高亮
    if (isNoDropdown) {
      setAction('');
    } else {
      setAction(item ? defaultValue : '');
    }
    setSortKey(item ? defaultKey : '');
    setTitle(item ? item?.title : titleProp);
  }, [defaultKey, defaultValue, titleProp, sortList]);

  const clickSort = (
    e: SortByListItemType,
    sortKey: string,
    action: '' | sortType,
    type?: string,
  ) => {
    if (type === 'font_sort') {
      setTitle(e?.title);
      setSortKey(e?.key);
      setAction('desc');
      return filter(e.key);
    }
    setTitle(e?.title);
    setSortKey(e?.key);
    let nextAction: sortType | '' =
      action == '' ? 'desc' : action == 'desc' ? 'asc' : action == 'asc' ? 'desc' : '';
    if (e.key !== sortKey) {
      nextAction = 'desc'; // 是当前指标排序但不是同一个排序时，从desc开始
    }
    nextAction = onlySimpleSort ? defaultValue : nextAction;
    // console.log(nextAction)
    setAction(nextAction);
    onChange({
      ...e,
      sortVal: nextAction === '' ? 'desc' : nextAction,
    });
  };

  // 标题数据源内容
  const sourceContent = (
    <div className="context-flex">
      {svgIcon ? <img src={svgIcon} className="table-header-img" /> : ''}
      {svgIcon1 ? <img src={svgIcon1} className="table-header-img" /> : ''}
    </div>
  );

  // 标题指标内容
  const metricContent = (
    <span
      className={`table-header-text ${action ? 'action-text' : ''}`}
      style={{ cursor: content ? 'pointer' : 'text' }}
    >
      {title}
    </span>
  );

  // 数据源与指标合并--标题内容
  const titleContentCur = useMemo(
    () => (
      <>
        {sourceContent}
        {metricContent}
      </>
    ),
    [sourceContent, metricContent],
  );

  // 数据源与指标合并--浮窗内容
  const contentCur = useMemo(() => {
    const iconContent = !svgIcon ? null : (
      <div className="svg-tip-context div-table-header-svg-tip-context"> {svgTip} </div>
    );

    // console.debug('in contentCur', { props, svgTip, content })

    return (
      <>
        <div className="div-table-header-svg-tip-context">{content}</div>
        {iconContent}
      </>
    );
  }, [svgTip, content, svgIcon]);

  return (
    <div
      key={title}
      className={classNames(className, {
        'dbi-table-header-flex-left': align === 'left',
        'dbi-table-header-flex': align === 'right',
        'dbi-table-column-title--has-tips': titlePointerCursor,
      })}
    >
      {/* 新增指标与数据源合体区域 */}
      {keysContent && <TipContext AWidth={500} styles={{margin: '0 5px'}} Performance="left" tipText={keysContent &&formatMessage({ id: keysContent })} /> }
      {!keysContent && !!svgTip || !!content ? (
        <Bubble
          dark
          style={{ maxWidth }}
          // trigger="click"
          content={
            !showTips ? null : (
              <div
                ref={bubbleContentRef}
                className="svg-tip-context div-table-header-svg-tip-context"
                onClick={handleBubbleContentClick}
              >
                {contentCur}
              </div>
            )
          }
        >
          <div className="content-sourcetitle-div">{titleContentCur}</div>
        </Bubble>
      ) : (
        <>
          {/* 原有分开区域，这里直接传入提示的结构 字体和svg已设置 */}
          <Bubble
            dark
            style={{ maxWidth: 500 }}
            content={!svgTip ? null : <div className="svg-tip-context"> {svgTip} </div>}
          >
            {sourceContent}
          </Bubble>
          <Bubble dark content={content}>
            {metricContent}
          </Bubble>
        </>
      )}

      {/* 有些表格有提示 传入tipText即可 ，默认不传不显示 */}
      {tipText ? <TipContext className="tip-text-hd" tipText={tipText} /> : ''}

      {/* eslint-disable-next-line no-nested-ternary */}
      {isNoDropdown ? (
        ''
      ) : /** 没有下拉但是有排序按钮 */
      list?.length === 1 ? (
        <div
          className="dbi-sort-table"
          onClick={() => {
            const firstItem = sortList?.[0];
            if (!firstItem) return;
            clickSort(firstItem, sortKey, action, type);
          }}
        >
          <SortIcon sortKey={sortKey} action={action} />
        </div>
      ) : (
        /** 展示有下拉的排序按钮 */
        <Dropdown
          boxClassName={classNames('dbi-sort-by', dropdownBoxClassName)}
          className="dbi-sort-table dbi-sort-dropdown"
          appearance="pure"
          trigger="click"
          disabled={disabled}
          button={<SortIcon sortKey={sortKey} action={action} disabled={disabled} />}
        >
          <List type="option">
            <div className="text-desc">{formatMessage({ id: 'dbi_sortby' })}</div>
            {sortList?.map((e, index) => (
              <List.Item
                key={e.key}
                onClick={() => {
                  const selected = sortList?.[index];
                  if (!selected) return;
                  clickSort(selected, sortKey, action, type);
                }}
              >
                <SvgIcon
                  type={
                    // eslint-disable-next-line no-nested-ternary
                    sortKey === e?.key && action === 'desc'
                      ? 'arrow-big-down'
                      : sortKey === e?.key && action === 'asc'
                      ? 'arrow-big-up'
                      : 'sort-icon'
                  }
                  className="text-icon"
                />
                {e?.text || e?.title}
              </List.Item>
            ))}
          </List>
        </Dropdown>
      )}
    </div>
  );
}

export const SortIcon = (props: any) => {
  const { sortKey, action, disabled } = props;
  return (
    <>
      <SvgIcon
        type={
          sortKey === ''
            ? 'sort-icon' // 不是当前排序值则为sort
            : action == 'desc'
            ? 'arrow-big-down'
            : action == 'asc'
            ? 'arrow-big-up'
            : 'sort-icon'
        }
        // className={`table-header-tip  ${action ? 'action-icon' : ''} `}
        className={classNames('table-header-tip', { 'action-icon': action, disabled })}
      />
    </>
  );
};
